import { render, staticRenderFns } from "./PipelineTabPhase.vue?vue&type=template&id=48ba64b5&"
import script from "./PipelineTabPhase.vue?vue&type=script&lang=ts&"
export * from "./PipelineTabPhase.vue?vue&type=script&lang=ts&"
import style0 from "./PipelineTabPhase.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports